<div class="h-100">
  <div *ngIf="!isViewTeamDashboard" class="card learners">
    <div class="card-head d-flex justify-content-between">
      <span class="card-head-text h5">Top Learners</span>
      <span class="head-helper h5">Programs Completed</span>
    </div>
    <hr>
    <div class="d-flex align-items-center justify-content-center h-100 w-100 fs-12" *ngIf="topLearners?.length == 0">
      <div class="grey-black-clr">No Learners</div>
    </div>
    <div class="card-content pb-2" *ngIf="topLearners?.length > 0">
      <ng-container *ngFor="let learner of topLearners; let i = index;">
        <div class="top-learners" *ngIf="i < 4">
          <div class="d-flex mt-2">
            <div class="col-10">
              <img src="../../../../assets/images/employeeCareer/user.png" style="height: 29px;">
              <span class="pl-2 learner-name h5 ">{{learner.employeeName}}</span>
            </div>
            <div class="col-2 learner-count">
              <span class="h5 fw-600">{{learner.count}}</span>
            </div>
          </div>
        </div>
        <hr *ngIf="i <3" class="transparent-hr">
      </ng-container>
    </div>
  </div>

  <div *ngIf="isManager && isViewTeamDashboard" class="card learners">
    <div class="card-head d-flex justify-content-between">
      <span class="card-head-text h5">My Team - Top Learners</span>
      <span class="head-helper h5">Programs Completed</span>
    </div>
    <hr>
    <div class="d-flex align-items-center justify-content-center h-100 w-100 fs-12" *ngIf="teamTopLearners?.length == 0">
      <div class="no-data">No Learners</div>
    </div>
    <div class="card-content pb-2 pt-1" *ngIf="teamTopLearners?.length > 0">
      <ng-container *ngFor="let learner of teamTopLearners; let i = index;">
        <div class="top-learners" *ngIf="i < 4">
          <div class="d-flex mt-2">
            <div class="col-10">
              <img src="../../../../assets/images/employeeCareer/user.png">
              <span class="pl-2 learner-name h5">{{learner?.employeeName}}</span>
            </div>
            <div class="col-2 learner-count">
              <span class="h5">{{learner?.count}}</span>
            </div>
          </div>
        </div>
        <hr *ngIf="i < teamTopLearners?.length - 1" class="transparent-hr">
      </ng-container>
    </div>
  </div>
</div>
